import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "./data";
import { Eyebrow, Reveal } from "./Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-[#F2EEE6] py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow dark>FAQ</Eyebrow>
        <h2 className="font-display mt-4 text-6xl uppercase leading-[0.9] text-[#0D0D0B] sm:text-8xl">Good<br />questions.</h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible defaultValue="faq-0" className="border-t-2 border-[#0D0D0B]">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} data-testid={`faq-accordion-item-${i}`} className="border-b-2 border-[#0D0D0B]/15">
              <AccordionTrigger className="py-6 text-left text-lg font-bold text-[#0D0D0B] hover:no-underline sm:text-2xl [&>svg]:h-6 [&>svg]:w-6">
                <span className="flex gap-5"><span className="font-display text-xl text-[#8A5A00] sm:text-2xl">0{i + 1}</span>{f.q}</span>
              </AccordionTrigger>
              <AccordionContent className="pb-6 pl-10 text-base text-[#3a3a35] sm:pl-12 sm:text-lg">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
